import React, { Component } from 'react';
import { LayoutContext } from '../modules/ContextModules/LayoutContext';

export class SearchParamProcess extends Component {
    static contextType = LayoutContext;

    constructor(props) {
        super(props);
        this.state = {
        };

    }
    componentDidMount() {
        window.gMainMap.asyncWaitIsReady.then(() => {
            this.process()
        })
    }
    process() {
        const { travelDiaryToolContext } = this.context;
        let searchParams = (new URL(document.location)).searchParams;
        let token = searchParams.get("token");
        if (token !== null) {
            travelDiaryToolContext.update({ token: token });
            this.readTokenRecord(token);
        }
    }
    async readTokenRecord(token) {
        this.context
            .draggableWindowContext["travelDiaryTool"]
            .update({
                isOpened: true
            });
    }
    render() {
        return (<></>)
    }
}